<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body px-0 pb-2">
          <h2 class="card-title px-3">{{ title }}</h2>
          <div class="px-3">
            <canvas :id="'chart' + chartId" style="height: 250px"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  name: "Chart",
  props: {
    type: String,
    config: String,
    title: String,
    labels: Array,
    label1: String,
    data1: Array,
    label2: String,
    data2: Array,
    barThickness: Number,
  },
  data() {
    return {
      chartId: Math.floor(Math.random() * 1000),
    };
  },
  mounted() {
    const ctx = document
      .getElementById("chart" + this.chartId)
      .getContext("2d");
    const mockConfig = {
      type: this.type,
      data: {
        labels: this.labels,
        datasets: [
          {
            label: this.label1,
            type: this.type,
            data: this.data1,
            backgroundColor: "#CC0B7A",
            barThickness: this.barThickness || 8,
          },
          {
            label: this.label2,
            type: this.type,
            data: this.data2,
            backgroundColor: "#4D1B38",
            barThickness: this.barThickness || 8,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "top",
            align: "end",
            boxWidth: 10,
            labels: {
              pointStyle: "circle",
              pointRadius: 5,
              usePointStyle: true,
            },
          },
        },
        tooltips: {
          enabled: false,
        },
        title: {
          display: false,
        },
        scales: {
          y: {
            stacked: false,
            offset: false,
            grid: {
              tickLength: 0,
            },
            ticks: {
              beginAtZero: true,
              fontFamily: "'dm_sansregular', sans-serif",
              fontSize: 11,
              padding: 10,
              callback: function (value) {
                return `${value}`;
              },
            },
          },
          x: {
            grid: {
              tickLength: 0,
            },
          },
        },
      },
    };
    const config = this.config ? this.config : mockConfig;
    new Chart(ctx, config);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
